import { useRef, useState } from 'react'
import AMapLoader from '@amap/amap-jsapi-loader'
import locationImg from './assets/location.png'

const defaultCenter = [110.527831, 40.578253]

const useAmap = (containerSlug) => {
  const [AMap, setAMap] = useState(null)
  const [amap, setAmap] = useState(null)

  // 初始化地图
  const init = (theme) => {
    return AMapLoader.load({
      key: '0e4f7b5e424e7db93755cb5d48e71a75',
      version: '2.0',
      plugins: [
        'AMap.MouseTool',
        'AMap.PolyEditor',
        'AMap.Geocoder',
        'AMap.AutoComplete',
        'AMap.PlaceSearch',
        'AMap.GeoJSON',
        'AMap.MapType',
      ],
      Loca: {
        version: '2.0.0',
      },
    }).then((Amap) => {
      const _amap = new Amap.Map(containerSlug, {
        center: defaultCenter,
        zoom: 14,
        mapStyle: `amap://styles/${theme}`,
      })
      _amap.addControl(new Amap.MapType())
      setAMap(Amap)
      setAmap(_amap)
      return Amap
    })
  }

  const defaultMarkerContent = (num) => {
    return (
      '' +
      '<div class="custom-content-marker">' +
      '   <img class="custom-icon" src="' +
      locationImg +
      '">' +
      '<span class="marker-num">' +
      num +
      '</span>' +
      '</div>'
    )
  }

  // const activeMarkerContent = (num) => {
  //   return (
  //     '<div class="custom-content-marker" >' +
  //     '   <img class="custom-icon" src="' +
  //     locationImg +
  //     '" />' +
  //     '<span class="marker-active-num">' +
  //     num +
  //     '</span>' +
  //     '<div class="close-btn" id="delete-btn" onclick="clearMarker(' +
  //     num +
  //     ')" ></div>' +
  //     '</div>'
  //   )
  // }

  const activeMarkerContent = () => {
    return (
      '<div class="custom-content-marker" >' +
      '   <img class="custom-icon" src="' +
      locationImg +
      '" />' +
      '</div>'
    )
  }

  const getGeocoder = () => {
    return new AMap.Geocoder({
      city: '全国',
      radius: 1000,
    })
  }

  const setCenter = (c) => {
    amap.setCenter(c)
  }

  // jeojson回显
  // 回显
  const showJeojson = (jeoJSON, { polygonEvents, markerEvents }) => {
    const geoJson = new AMap.GeoJSON({
      geoJSON: jeoJSON,
      getPolygon: (geojson, lnglats) => {
        const polygon = new AMap.Polygon({
          path: lnglats,
          strokeColor: '#0056fe',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: 'white',
          fillOpacity: 0,
          strokeStyle: 'solid',
          draggable: true,
          cursor: 'move',
        })

        if (lnglats[0] && lnglats[0][0]) {
          polygonEvents(polygon, lnglats)
          // addPolygonMultipleEvents(polygon, {
          //   path: lnglats[0][0].map((d) => {
          //     return new AMap.LngLat(d[0], d[1])
          //   }),
          //   event: setIsEditRegion,
          //   dragEvent: dragendEvent,
          //   addPolygonEvent,
          //   updateCurrentGeo,
          // })
        }
        return polygon
      },
      getMarker: ({ geometry }) => {
        const { coordinates } = geometry

        const options = {
          position: coordinates,
          content: activeMarkerContent(),
          draggable: true,
          cursor: 'move',
        }
        const marker = new AMap.Marker(options)
        markerEvents(marker, coordinates)
        // addMarkerMultipleEvents(marker, { lnglat: coordinates })
        return marker
      },
    })

    amap.add(geoJson)
  }

  // 绘制区域相关

  // 启动多边形编辑
  const polyEditor = useRef()
  const polyEditorCurrentEvent = useRef()

  const openRegionEdit = (polygon, event, addPolygonEvent) => {
    polyEditor.current = new AMap.PolyEditor(amap, polygon)
    polyEditor.current.open()
    polyEditor.current.on('end', (e) => {
      const { target } = e
      const firstPosition = target.getPath()[0]
      const { lng, lat } = firstPosition
      // 更新区域地址
      addPolygonEvent(polygon, [lng, lat], true)
    })
    if (event) {
      polyEditorCurrentEvent.current = event
      event(true)
    }
  }

  // 关闭多边形编辑
  const closeRegionEdit = () => {
    polyEditor.current.close()
    polyEditor.current = null
    polyEditorCurrentEvent.current(false)
  }

  const addPolygonMultipleEvents = (
    polygon,
    { mouseTool, path, event, dragEvent, addPolygonEvent, updateCurrentGeo }
  ) => {
    // 拖拽事件
    dragEvent(polygon)
    // 添加到list(应获取获取中心点)
    addPolygonEvent(polygon, path[0])
    // 选中事件
    polygon.on('click', () => {
      amap.clearEvents('click')
      if (polyEditor.current) {
        closeRegionEdit()
      }
      polygon.setOptions({
        ...polygon,
        fillColor: '#0056fe',
        fillOpacity: 0.5,
        strokeOpacity: 1,
      })
      // 更新当前选中项
      updateCurrentGeo(polygon)
    })
    polygon.on('mouseover', () => {
      const { fillOpacity } = polygon.getOptions()
      if (fillOpacity === 0) {
        polygon.setOptions({
          ...polygon,
          fillColor: '#0056fe',
          fillOpacity: 0.3,
          strokeOpacity: 0.65,
        })
      }
    })
    polygon.on('mouseout', () => {
      const { fillOpacity } = polygon.getOptions()
      if (fillOpacity === 0.3) {
        polygon.setOptions({
          ...polygon,
          fillColor: 'white',
          fillOpacity: 0,
          strokeOpacity: 0.8,
        })
      }
    })

    // 双击编辑
    polygon.on('dblclick', () => {
      if (mouseTool) {
        mouseTool.close()
      }
      // 先关闭 再开启
      if (polyEditor.current) {
        closeRegionEdit()
      }
      updateCurrentGeo(polygon)
      openRegionEdit(polygon, event, addPolygonEvent)
    })
  }

  // 添加多边形
  const addPolygon = (
    mouseTool,
    path,
    event,
    dragEvent,
    addPolygonEvent,
    updateCurrentGeo
  ) => {
    // 只有选中后才能被拖拽
    const options = {
      path,
      strokeColor: '#0056fe',
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: 'white',
      fillOpacity: 0,
      strokeStyle: 'solid',
      draggable: true,
      cursor: 'move',
    }
    const polygon = new AMap.Polygon(options)
    // 为区域添加一系列事件
    addPolygonMultipleEvents(polygon, {
      mouseTool,
      path,
      event,
      dragEvent,
      addPolygonEvent,
      updateCurrentGeo,
    })
    amap.add(polygon)
    updateCurrentGeo(polygon)
    amap.setFitView()
  }

  // 绘制多边形
  const drawPolygon = (event, dragEvent, addPolygonEvent, updateCurrentGeo) => {
    const mouseTool = new AMap.MouseTool(amap)
    mouseTool.polygon({
      strokeColor: '#0056fe',
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: 'white',
      fillOpacity: 0,
      strokeStyle: 'solid',
    })
    AMap.Event.addListener(mouseTool, 'draw', (e) => {
      amap.remove(e.obj)
      // 添加多边形
      addPolygon(
        mouseTool,
        e.obj.getPath(),
        event,
        dragEvent,
        addPolygonEvent,
        updateCurrentGeo
      )
    })
  }

  return {
    init,
    amap,
    AMap,
    setCenter,
    getGeocoder,
    drawPolygon,
    closeRegionEdit,
    defaultMarkerContent,
    activeMarkerContent,
    addPolygon,
    addPolygonMultipleEvents,
    showJeojson,
  }
}
export default useAmap
